intra_module.controller('PersonalInfoSheetCtrl', function($scope, $location, ngNotify, api_url) {
	$scope.infos = {};
	$scope.errors = {};

	// TODO: when PR#406 has been merged, this should be replaced by injecting hub_api_url in this controller.
	const hub_api_url = api_url.replace("//intra-api.", "//api.");
	const my_student_info_url = `${hub_api_url}/intra/my-student-infos`;

	function fetchPersonalInfos() {
		fetch(my_student_info_url, { credentials: "include"})
			.then( (response) => {
				if (!response.ok) {
					throw new Error("Erreur lors de la récupération des informations de l'étudiant.");
				}
				return response.json();
			})
			.then( (js) => {
				$scope.infos = js;
				// pole_emploi_status needs to be a string for select/option to work.
				$scope.infos.pole_emploi_status = '' + js.pole_emploi_status;
				if (js.pole_emploi_date !== null) {
					$scope.infos.pole_emploi_date = new Date(js.pole_emploi_date);
				}
			}).catch( (err) => {
				ngNotify.set('Erreur lors de la récupération des informations administratives.', 'error');
				console.log('failed to fetch student infos:', err);
			});
	}

	function commitPersonalInfos() {
		const body = {};
		for (const key in $scope.infos) {
			body[key] = $scope.infos[key];
		}
		if ($scope.infos.pole_emploi_date !== null) {
			const date = $scope.infos.pole_emploi_date;
			body.pole_emploi_date = date.toISOString().substr(0, 10);
		}
		fetch(my_student_info_url, {
			method: "PUT",
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
			credentials: "include",
		}).then( (response) => {
			if (!response.ok) {
				throw new Error("Echec de la déclaration.");
			} else {
				ngNotify.set('Mise à jour des informations adminitratives effectué.', 'success');
			}
		}).catch( (err) => {
			ngNotify.set('Error lors de la mise à jour des information administratives.', 'error');
			console.log('failed to commit student infos:', err);
		});
	}

	function errorIfEmpty(field, errors) {
		const value = $scope.infos[field];
		if (value == "" || value === undefined || value === null) {
			errors.set(field, 'Ce champs doit être renseigné.');
		}
	}

	$scope.submitForm = function() {
		const errors = new Map();
		$scope.errors = {};

		errorIfEmpty('birthplace_zip_code', errors);
		errorIfEmpty('birthplace', errors);
		errorIfEmpty('social_number', errors);
		errorIfEmpty('pole_emploi_status', errors);
		errorIfEmpty('referent', errors);
		errorIfEmpty('emergency_contact', errors);
		if ($scope.infos.pole_emploi_status == "1") {
			errorIfEmpty('pole_emploi_number', errors);
			errorIfEmpty('pole_emploi_date', errors);
		} else {
			$scope.infos.pole_emploi_number = null;
			$scope.infos.pole_emploi_date = null;
		}
		if (errors.size) {
			// if there are any errors, copy into scope (to notify user) and abort submission.
			for (const [key, message] of errors.entries()) {
				$scope.errors[key] = message;
			}
			return;
		}
		commitPersonalInfos();
		// $location.path('/');
	};

	fetchPersonalInfos();
});
